/** @format */

import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import CustomButton from '../custom-button/custom-button.component';
import FormInput from '../form-input/form-input.component';
import Modal from '../modal/modal.component';
import Multiselect from 'multiselect-react-dropdown';
import MessageSelector from '../message-selector/message-selector.component';
import CustomerByFlightViz from '../customerByFlight-viz/customerByFlight-viz.component';
import PulseLoader from 'react-spinners/PulseLoader';
import MessageHistoryComponent from '../message-history/message-history.component';
import TimeRangePicker from '../time-range-picker/time-range-picker.component';
import { selectCustomerData } from '../../redux/customers/customer.selector';
import { selectCurrentUser } from '../../redux/user/user.selector';
import {
  selectMessageValue,
  selectMessageType,
  selectMessageSubject,
  selectMessageHtml,
  selectMessageTemplateId,
  selectMessageData,
} from '../../redux/message/message.selector';
import {
  selectFlightIds,
  selectFlightCustomerData,
  selectIsFlightIdsLoading,
  selectDof,
  selectSelectedFlightIds,
  selectIsCustomerDataLoading,
  selectCustomerCount,
  selectFilteredFlightIds,
} from '../../redux/flightData/flightData.selector';

import {
  setDof,
  setSelectedFlightIds,
  getFlightIdsStart,
  getCustomerDataStart,
} from '../../redux/flightData/flightData.actions';
import {
  updateMessageData,
  clearCustomerSelection,
} from '../../redux/customers/customer.actions';

import {
  sendEmailStart,
  sendTextStart,
} from '../../redux/message/message.actions';

import {
  SurveyFormContainer,
  SurveyTitle,
  RadioButtonsContainer,
  VizContainer,
} from './survey-form-twilio.styles';
import { socket } from '../../utils/socketIo';

class SurveyFormTwilio extends React.Component {
  constructor(props) {
    super(props);
    this.multiselectRef = React.createRef();

    this.state = {
      modalOpen: false,
      warningModalOpen: false,
      // voucherData: null,
      // selectedISSIDs: [],
      // ISSIDs: [],
      selectAll: false,
    };
    this.onSearch = this.onSearch.bind(this);
  }

  componentDidMount() {
    socket.on('textStatusUpdate', this.handleStatusUpdateEvent);
    socket.on('emailStatusUpdate', this.handleStatusUpdateEvent);
  }

  componentWillUnmount() {
    socket.off('emailStatusUpdate', this.handleStatusUpdateEvent);
    socket.off('textStatusUpdate', this.handleStatusUpdateEvent);
  }

  handleStatusUpdateEvent = (data) => {
    this.props.updateMessageData(data);
  };

  sendText = () => {
    if (this.props.selectedFlights.length > 0) {
      if (this.props.messageValue.length > 5) {
        this.props.sendTextStart();
        this.toggleModal();
      } else {
        alert('Length of message is too short.');
      }
    } else {
      alert('Select a Flight ID!');
    }
  };

  sendEmail = () => {
    if (this.props.selectedFlights.length > 0) {
      if (this.props.messageValue.length > 5) {
        this.props.sendEmailStart();
        this.toggleModal();
      } else {
        alert('Length of message is too short.');
      }
    } else {
      alert('Select a Flight Id!');
    }
  };

  toggleModal = () => {
    this.setState({ modalOpen: !this.state.modalOpen });
  };

  toggleWarningModal = () => {
    this.setState({ warningModalOpen: !this.state.warningModalOpen });
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    if (this.props.selectedFlights.length > 0) {
      this.props.getCustomerDataStart();
    } else {
      this.props.getFlightIdsStart();
    }
  };

  handleSelectAll = () => {
    this.setState({ selectAll: !this.state.selectAll }, () => {
      if (
        this.state.selectAll &&
        this.multiselectRef.current.searchBox.current.value !== undefined &&
        this.multiselectRef.current.searchBox.current.value !== ''
      ) {
        this.onSearch(this.multiselectRef.current.searchBox.current.value);
      } else {
        this.onSearch('');
      }
    });
  };

  onSelect = (selectedList) => {
    this.props.setSelectedFlightIds(selectedList);
  };

  onRemove = (selectedList) => {
    this.props.setSelectedFlightIds(selectedList);
    this.props.clearCustomerSelection();
  };

  onSearch = (search) => {
    let temp = this.props.selectedFlights;

    if (this.state.selectAll && search !== undefined) {
      this.props.flightIds.forEach((flightId) => {
        if (flightId.indexOf(search) !== -1) {
          if (!temp.includes(flightId)) {
            temp.push(flightId);
          }
        } else {
          temp = temp.filter(function (value) {
            return value !== flightId;
          });
        }
      });
    }
    if (search === '' && this.state.selectAll) {
      temp = [];
      this.multiselectRef.current.resetSelectedValues();
      this.props.setSelectedFlightIds(temp);
      this.props.clearCustomerSelection();
    } else {
      this.props.setSelectedFlightIds(temp);
    }
  };

  handleChange = (event) => {
    this.multiselectRef.current.resetSelectedValues();
    const { value, name } = event.target;
    if (name === 'dof') {
      this.props.setDof(value);
    }

    this.setState({ [name]: value });
    this.setState({ voucherData: null });
    this.setState({ ISSIDs: [] });
    this.props.setSelectedFlightIds([]);
    this.props.clearCustomerSelection();
  };

  render() {
    return (
      <VizContainer>
        <SurveyFormContainer>
          <SurveyTitle>JSX messaging</SurveyTitle>

          <form onSubmit={this.handleSubmit}>
            <FormInput
              name="dof"
              type="date"
              handleChange={this.handleChange}
              value={this.props.dof}
              label="Date of Flight"
              id="dof"
              required
              min="2016-01-01"
            />
            <TimeRangePicker />
            <p>Flight</p>
            <Multiselect
              isObject={false}
              options={this.props.filteredFlightIds} // Options to display in the dropdown
              onSelect={this.onSelect} // Function will trigger on select event
              onRemove={this.onRemove} // Function will trigger on remove event
              onSearch={this.onSearch}
              avoidHighlightFirstOption={true}
              closeOnSelect={false}
              selectedValues={this.props.selectedFlights}
              showArrow={true}
              ref={this.multiselectRef}
              keepSearchTerm={true}
              placeholder={
                this.props.flightIds.length > 0
                  ? 'Select Flight/s'
                  : 'Select Date and Submit'
              }
              disable={
                this.props.flightIds.length > 0 &&
                !this.props.isFlightIdsLoading
                  ? false
                  : true
              }
              style={{
                chips: { background: 'red' },
                option: { fontSize: '15px' },
              }}
            />

            {/* // ! /////////////////  EXPERIMENTAL //////////////////// */}
            <div
              className="topping"
              style={{ display: 'flex', flexDirection: 'row' }}
            >
              <input
                type="checkbox"
                onChange={this.handleSelectAll}
                checked={this.selectAll}
                value="Paneer"
              />
              <p>Select All</p>
            </div>
            {/* // ! /////////////////  EXPERIMENTAL //////////////////// */}

            <RadioButtonsContainer>
              <CustomButton
                type="submit"
                disabled={this.props.flightIdsLoading}
              >
                {this.props.flightIds.length > 0 ? 'Search' : 'Submit'}
                {this.props.isFlightIdsLoading ? (
                  <PulseLoader
                    color="red"
                    loading="true"
                    size={3}
                    style={{ marginBottom: '5px' }}
                  />
                ) : null}
              </CustomButton>

              {/* <CustomButton type="button"> Cancel </CustomButton> */}
            </RadioButtonsContainer>
          </form>

          {this.state.modalOpen && (
            <Modal
              modalOpen={this.state.modalOpen}
              handleClose={this.toggleModal}
              text={`${this.props.messageType} Status`}
              type="dropIn"
              variant={'messageStatus'}
              data={this.props.selectCustomerData}
            />
          )}
          {this.state.warningModalOpen && (
            <Modal
              modalOpen={this.state.warningModalOpen}
              handleClose={this.toggleWarningModal}
              text={`Are you sure you want to send this ${this.props.messageType}?`}
              type="flip"
              variant={'messageWarning'}
              handleSend={
                this.props.messageType === 'Text'
                  ? this.sendText
                  : this.sendEmail
              }
              data={{
                type: this.props.messageType,
                template: this.props.messageSubject,
                flights: this.props.selectedFlights,
              }}
            />
          )}
        </SurveyFormContainer>
        {this.props.flightCustomerData ? (
          <CustomerByFlightViz
            hidden={!this.props.flightCustomerData}
            customerData={this.props.flightCustomerData}
            selectedFlights={this.props.selectedFlights}
            customerCount={this.props.customerCount}
          />
        ) : null}

        {this.props.flightCustomerData && (
          <MessageSelector hidden={!this.props.flightCustomerData} />
        )}
        {this.props.flightCustomerData && (
          <CustomButton type="button" onClick={this.toggleWarningModal}>
            Send {`${this.props.messageType}`}
          </CustomButton>
        )}
        {this.props.selectedFlights.length > 0 && <MessageHistoryComponent />}
      </VizContainer>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  selectCustomerData: selectCustomerData,
  flightIds: selectFlightIds,
  filteredFlightIds: selectFilteredFlightIds,
  flightCustomerData: selectFlightCustomerData,
  customerCount: selectCustomerCount,
  dof: selectDof,
  isFlightIdsLoading: selectIsFlightIdsLoading,
  isCustomerDataLoading: selectIsCustomerDataLoading,
  selectedFlights: selectSelectedFlightIds,
  currentUser: selectCurrentUser,
  messageValue: selectMessageValue,
  messageType: selectMessageType,
  messageSubject: selectMessageSubject,
  messageHtml: selectMessageHtml,
  messageTemplateId: selectMessageTemplateId,
  messageData: selectMessageData,
});

const mapDispatchToProps = (dispatch) => ({
  updateMessageData: (customer) => dispatch(updateMessageData(customer)),
  clearCustomerSelection: () => dispatch(clearCustomerSelection()),
  getCustomerDataStart: () => dispatch(getCustomerDataStart()),
  getFlightIdsStart: () => dispatch(getFlightIdsStart()),
  setDof: (dof) => dispatch(setDof(dof)),
  setSelectedFlightIds: (flightIds) =>
    dispatch(setSelectedFlightIds(flightIds)),

  sendEmailStart: () => dispatch(sendEmailStart()),
  sendTextStart: () => dispatch(sendTextStart()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SurveyFormTwilio);
